import styled from 'styled-components';

export const InfoRow = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
`;

export const Row = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 100%;
`;

export const RowRight = styled(Row)`
    justify-content: flex-end;
`;

export const Column = styled.div`
    display: flex;
    flex-direction: column;
    align-items: left;
    width: 100%;
`;

export const TitleRow = styled(InfoRow)`
    margin-bottom: 20px;
`;

export const PopupContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px;
`;



// WEBPACK FOOTER //
// ./src/components/atoms/tables/smarttables/layout/flex.js